import {AvailablePropertyFieldType} from '../type/available-property-field.type';
import {AvailablePropertyType} from '../enum/available-property.type';

export class Property {
  constructor(
    public readonly name: string,
    public readonly fieldType: AvailablePropertyFieldType,
    public readonly value: string,
    public readonly propertyType: AvailablePropertyType
  ) {
  }
}
